import { Box, Stack } from '@mui/material'

import FeedTableIcon from 'assets/FeedTableIcon'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary12 } from 'ui/typography/TypographyPrimary12'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { BaseWidget } from '../../../baseWidget'

export const RemainingFeedWidgetSmall = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_food_table || error) return null

	const leftover = statistics?.cleaning?.total

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.mainSecondaryOpacity,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<FeedTableIcon color={COLORS.main} width={16} height={16} />
				</Box>
			}
			path={'/feed/'}
			isLoading={loading}
		>
			<Stack direction='column' gap='4px'>
				{(leftover || leftover === 0) && (
					<Stack direction='row' alignItems='baseline' gap='4px'>
						<TypographyPrimary16Bold>{leftover}</TypographyPrimary16Bold>
						<TypographyPrimary12>кг</TypographyPrimary12>
					</Stack>
				)}
				<TypographyPrimary>Суммараный статок</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
